import ApiUtil from '../api/api.util'
import ApiConfig from '../api/api.config'
import EtnersEncDecUtil from '@/common/etners.encDec.util'


const getCodeIsMatched = function (option, codeMap) {
  if (codeMap[option.cdGrup] == undefined) {
    return null
  }

  const codeByCdGrupArray = codeMap[option.cdGrup]

  for (let i = 0; i < codeByCdGrupArray.length; i++) {
    const code = codeByCdGrupArray[i]

    if (code.cdNm == option.cdNm) {
      return code
    }
  }

  return null
}

/**
 * 목록 화면에서 검색 조건이 있을경우 검색조건(filters)를 return함
 */
const getLastRouteParams = function (lastRouteParams) {
  const filterArray = lastRouteParams.filter
  const returnLastRouteParams = {}

  if (isNotEmpty(filterArray)) {
    // 등록일 value값 세팅
    if (Object.keys(lastRouteParams).length > 0 && lastRouteParams.filter.length > 0) {
      filterArray.forEach(filter => {
        const arr = filter.filters
        if (arr[0].field === 'inputDt' || arr[0].field === 'frstRgstDt' || arr[0].field === 'workRequestDt') {
          returnLastRouteParams[arr[0].field + 'Start'] = EtnersDateTimeUtil.lookupDateYYYYMMDD(arr[0].value)
          returnLastRouteParams[arr[0].field + 'End'] = EtnersDateTimeUtil.lookupDateYYYYMMDD(arr[1].value)
        } else {
          let fieldId = arr[0].field

          // 조인컬럼의 경우 필드명 구조가 "entity.column" 구조이며, 해당 구조를 element value 속성에서 filed명으로 인식되지 않으므로 가공 처리.
          if (fieldId.indexOf('.') > -1) {
            fieldId = fieldId.split('.')[0] + 'Dot' + fieldId.split('.')[1]
          }

          returnLastRouteParams[fieldId] = arr[0].value
        }
      })
    }
  }

  return returnLastRouteParams
}

const sortArrayByName = function (obj, sortColumn) {
  if(obj !== undefined){
    obj.sort((f, l) => {
      const fa = f[sortColumn].toLowerCase()
      const fb = l[sortColumn].toLowerCase()

      if (fa < fb) {
        return -1
      }
      if (fa > fb) {
        return 1
      }
      return 0
    })
  }

  return obj
}

const lookupSolutionCodeByCodeName = function (option) {
  if (COMMON_SOL_CD_MAP[option.solCd] == undefined) {
    return null
  } else {
    const codeMap = COMMON_SOL_CD_MAP[option.solCd]

    return getCodeIsMatched(option, codeMap)
  }
}

const lookupCompanyCodeByCodeName = function (option) {
  if (COMMON_CMPY_CODE_MAP[option.cmpyCd] == undefined) {
    return null
  } else {
    const codeMap = COMMON_CMPY_CODE_MAP[option.cmpyCd]

    return getCodeIsMatched(option, codeMap)
  }
}

const isNumber = (arg) => {
  // 문자열로 변환
  arg += ''

  // 좌우 공백 제거
  arg = arg.replace(/^\arg*|\arg*$/g, '')

  if (arg == '' || isNaN(arg)) {
    return false
  }

  return true
}

const getMatchType = (arg) => {
  if (arg === undefined || arg === null) {
    throw new Error('정의되지 않은 인자를 넣을 수 없습니다.')
  }

  let constructor = arg.constructor

  if (constructor == Number && isNumber(arg)) {
    return 'NUMBER'
  } else if (constructor == Object) {
    return 'OBJECT'
  } else if (constructor == String) {
    return 'STRING'
  } else if (constructor == Array) {
    return 'ARRAY'
  } else if (typeof arg === 'function') {
    return 'FUNCTION'
  } else if (typeof arg === 'object') {
    return 'OBJECT'
  } else {
    throw new Error('검증되지 않은 타입이 존재합니다.')
  }
}

const isEmpty = (arg) => {
  if (arg === undefined || arg === null || arg === 'null') {
    return true
  }

  let type = getMatchType(arg)

  let flag = false

  switch (type) {
    case 'NUMBER' :
      flag = false
      break
    case 'ARRAY' :
      flag = arg.length == 0
      break
    case 'STRING' :
      try {
        flag = arg.trim().length == 0
      } catch (e) {
        String.prototype.trim = function () {
          return this.replace(/^\s+|\s+$/g, '')
        }

        flag = arg.trim().length == 0
      }
      break
    case 'OBJECT' :
      try {
        flag = Object.keys(arg).length == 0
      } catch (e) {
        let count = 0

        for (const key in arg) {
          count++
        }

        flag = count == 0
      }
      break
  }

  return flag
}

const isNotEmpty = (arg) => {
  return !isEmpty(arg)
}

const isNotNull = (arg) => {
  return !(arg === undefined || arg === null)
}
/**
 * 숫자 3자리마다 콤마(,)를 찍어서 리턴함.
 *
 */
const numberWithCommas = function (number) {
  const n = parseInt(number)

  if (isNaN(n)) {
    return number
  }

  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 * 문자열에 콤마가 있는 경우 제거함.
 *
 */
const removeCommasInText = function (n) {
  if (typeof n === 'undefined' || n == null) {
    return 0
  }

  const txtNumber = '' + n
  return parseInt(txtNumber.replace(/(,)/g, ''))
}

/**
 * 텍스트에서 숫자만 추출해서 리턴함. 없으면 빈 문자열을 리턴
 *
 */
const extractOnlyNumbers = function (text) {
  if (text + '' == 'NaN') {
    return ''
  }

  switch (getMatchType(text)) {
    case 'STRING' :
      return text.replace(/[^0-9]/g, '')
    case 'NUMBER' :
      return text
    default :
      return ''
  }
}

const sortArray = function (obj, sortColumn) {
  obj.sort(function (f, l) {
    // assuming distance is always a valid integer
    return parseInt(f[sortColumn], 10) - parseInt(l[sortColumn], 10)
  })
  return obj
}

const getLoginUserDataJson = function(column) {

  const loginUserDataJson = JSON.parse(sessionStorage.getItem('loginUserData'))

  if(isEmpty(column)) {
    return loginUserDataJson
  } else {
    return loginUserDataJson[column]
  }

}


/**
 * 전달 받은 인자가 정수값(양수, 공백x) 인지 체크
 *
 */
const isPositiveInteger = function (value) {
  const pattern = /^[1-9]\d*$/

  if (value === '') {
    return true
  }

  if (pattern.test(value)) {
    return true
  } else {
    return false
  }
}

/**
 * 전달 받은 인자가 정수값(0허용, 공백x) 인지 체크
 *
 */
const isInteger = function (value) {
  const pattern = /^(0|[1-9]\d*)$/

  if (value === '') {
    return true
  }

  if (pattern.test(value)) {
    return true
  } else {
    return false
  }
}

/**
 * 전달 받은 인자가 운송장 번호(영어, 숫자만 허용) 인지 체크
 *
 */
const isBlNo = function (value) {
  const pattern = /^[A-Za-z0-9]+$/

  if (value === '') {
    return true
  }

  if (pattern.test(value)) {
    return true
  } else {
    return false
  }
}

/**
 * 전달 받은 인자가 이메일 주소 형식 인지 체크 (xxxxxxx@xxxx.xxx)
 *
 */
const isEmailAddr = function (value) {
  const pattern = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i

  if (value === '') {
    return true
  }

  if (pattern.test(value)) {
    return true
  } else {
    return false
  }
}

/**
 * 로컬 환경인지 판단
 */
const isLocal = function() {
  const currentURL = window.location.href;
  if (currentURL.startsWith('http://localhost') || currentURL.startsWith('http://172.16')) { // 웹 페이지가 로컬에서 실행 중.
    return true
  }
  return false
}

/**
 * 로컬 환경인지 판단 -> 로그인 파라미터 설정
 */
const loginParams = async function (userId, userPwd, publicKey) {
  const userIdRSA = await EtnersEncDecUtil.encryptRSA(userId, publicKey) // 평문을 RSA 공개키로 암호화
  const userPwdRSA = await EtnersEncDecUtil.encryptRSA(userPwd, publicKey) // 평문을 RSA 공개키로 암호화
  let loginParams = {
    userId: userIdRSA,
    userPwd: userPwdRSA,
  }

  return loginParams
}

const charByteSize = function(ch) {
  if (ch == null || ch.length == 0) {
    return 0
  }

  let charCode = ch.charCodeAt(0)

  if (charCode <= 0x00007F) {
    return 1
  } else if (charCode <= 0x0007FF) {
    return 2
  } else if (charCode <= 0x00FFFF) {
    return 3
  } else {
    return 4
  }
}
/**
 * 글자 수 자르는 함수
 * @param s
 * @param len
 * @returns {string}
 */
const cutByteLength = function(s, len) {
  if (s == null || s.length == 0) {
    return ''
  }
  let size = 0
  let rIndex = s.length

  for ( let i = 0; i < s.length; i++) {
    size += charByteSize(s.charAt(i))
    if( size == len ) {
      rIndex = i + 1
      break
    } else if( size > len ) {
      rIndex = i
      break
    }
  }
  return s.substring(0, rIndex)
}

export default {
  isNumber,
  getMatchType,
  getLastRouteParams,
  getLoginUserDataJson,
  isEmpty,
  isNotNull,
  isNotEmpty,
  extractOnlyNumbers,
  sortArray,
  numberWithCommas,
  removeCommasInText,
  sortArrayByName,
  isPositiveInteger,
  isInteger,
  isBlNo,
  isEmailAddr,
  isLocal,
  loginParams,
  cutByteLength
}
